export default __webpack_public_path__ + "static/media/program-info-icon-active.def7b6b6.svg";